import { memo, PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Delayed } from 'src/common/Delayed/Delayed';
import { BelimoLoadingIcon } from '../icons/BelimoLoadingIcon';

type Props = {
    isLoading?: boolean;
} & PropsWithChildren

export const MainLayout = memo(({
    isLoading,
    children,
}: Props) => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.hash]);

    return (
        <div className="vss-main-layout">
            {isLoading && (
                <Delayed waitBeforeShow={200}>
                    <div className="vss-main-layout__loading-overlay">
                        <div className="vss-main-layout__loading-icon">
                            <BelimoLoadingIcon/>
                        </div>
                    </div>
                </Delayed>
            )}

            {children}
        </div>
    );
});
